import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalAgriculture() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Agriculture: Cultivating the Future with 5G Connectivity
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Enhance precision farming, livestock monitoring, and resource
          management with FlexNet's private 5G solutions tailored for
          agriculture.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">
              FlexNet Agriculture
            </span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Revolutionize your farming operations with FlexNet's high-speed
              private 5G networks. Achieve higher crop yields, efficient
              resource utilization, and real-time monitoring for smarter
              agriculture.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://img.freepik.com/premium-photo/internet-things-iot-with-farming-smart-concept-agriculture-modern-technology-are-used_926199-2243195.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">FlexNet for Agriculture?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Agriculture </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Transform Your Farming Operations?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Precision Monitoring of Soil and Crop Health",
    detail: "Utilize IoT sensors for data-driven farming decisions.",
    icon: "pi pi-search ",
  },
  {
    title: "Real-Time Livestock Tracking and Health Management",
    detail: "Monitor livestock health and location with smart wearables.",
    icon: "pi pi-map-marker",
  },
  {
    title: "Efficient Resource Utilization Through Automated Systems",
    detail: "Optimize water, fertilizer, and energy use with automation.",
    icon: "pi pi-cog",
  },
  {
    title: "Enhanced Data Analytics for Informed Decision-Making",
    detail: "Gain insights into farm conditions with real-time data.",
    icon: "pi pi-chart-bar",
  },
  {
    title: "Secure, Low-Latency Communication Across Vast Farmlands",
    detail: "Ensure seamless connectivity with private 5G networks.",
    icon: "pi pi-wifi",
  },
];

const useCases = [
  {
    title: " 1: Precision Crop Monitoring with IoT Sensors",
    description:
      "Deploy IoT sensors across fields to monitor soil moisture, nutrient levels, and environmental conditions in real-time, enabling data-driven farming practices.",
    benefits: [
      {
        title: "Optimize irrigation and fertilization schedules",
        icon: "pi pi-calendar ",
      },
      { title: "Enhance crop yield and quality", icon: "pi pi-star" },
      {
        title: "Reduce resource wastage and environmental impact",
        icon: "pi pi-sync ",
      },
    ],
    devices: [
      { title: "Soil Moisture Sensors", icon: "pi pi-cloud" },
      { title: "Environmental Sensors", icon: "pi pi-sun" },
      { title: "IoT Gateways", icon: "pi pi-server" },
    ],
    applications: [
      { title: "Precision Agriculture Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 2: Autonomous Agricultural Vehicles",
    description:
      "Implement 5G-connected autonomous tractors and harvesters for efficient field operations, reducing manual labor and increasing operational efficiency.",
    benefits: [
      {
        title: "Perform precise planting, harvesting, and maintenance tasks",
        icon: "pi pi-wrench",
      },
      {
        title: "Operate efficiently under various field conditions",
        icon: "pi pi-arrows-h",
      },
      { title: "Reduce labor costs and human error", icon: "pi pi-user-minus" },
    ],
    devices: [
      { title: "Autonomous Tractors", icon: "pi pi-car" },
      { title: "GPS Systems", icon: "pi pi-map" },
      { title: "Machine Vision Cameras", icon: "pi pi-camera" },
    ],
    applications: [{ title: "Farm Management Systems", icon: "pi pi-desktop" }],
  },
  {
    title: " 3: Drone-Based Crop Surveillance",
    description:
      "Utilize 5G-enabled drones equipped with multispectral sensors to monitor crop health, detect diseases, and assess field conditions from above.",
    benefits: [
      { title: "Rapid identification of crop issues", icon: "pi pi-eye" },
      {
        title: "Targeted intervention to affected areas",
        icon: "pi pi-crosshair",
      },
      {
        title: "Comprehensive field coverage with minimal effort",
        icon: "pi pi-globe",
      },
    ],
    devices: [
      { title: "Drones", icon: "pi pi-send" },
      { title: "Multispectral Cameras", icon: "pi pi-camera" },
      { title: "AI Analytics Platforms", icon: "pi pi-microchip" },
    ],
    applications: [{ title: "Crop Monitoring Systems", icon: "pi pi-desktop" }],
  },
  {
    title: " 4: Livestock Health Monitoring",
    description:
      "Equip livestock with 5G-connected wearables to monitor health metrics, location, and behavior patterns in real-time.",
    benefits: [
      { title: "Early detection of health issues", icon: "pi pi-heart" },
      {
        title: "Improved herd management and productivity",
        icon: "pi pi-users",
      },
      { title: "Enhanced traceability and biosecurity", icon: "pi pi-lock" },
    ],
    devices: [
      { title: "Smart Collars", icon: "pi pi-mobile" },
      { title: "Biometric Sensors", icon: "pi pi-chart-line" },
      { title: "GPS Trackers", icon: "pi pi-map" },
    ],
    applications: [
      { title: "Livestock Management Platforms", icon: "pi pi-desktop" },
    ],
  },
  {
    title: " 5: Smart Irrigation Systems",
    description:
      "Implement automated irrigation systems controlled via 5G connectivity, adjusting water delivery based on real-time soil and weather data.",
    benefits: [
      {
        title: "Optimize water usage and conservation",
        icon: "pi pi-sync",
      },
      {
        title: "Prevent overwatering and water stress",
        icon: "pi pi-exclamation-triangle",
      },
      { title: "Increase crop yield and quality", icon: "pi pi-chart-line " },
    ],
    devices: [
      { title: "Automated Valves", icon: "pi pi-cog" },
      { title: "Soil Moisture Sensors", icon: "pi pi-cloud" },
      { title: "Weather Stations", icon: "pi pi-sun" },
    ],
    applications: [
      { title: "Irrigation Management Systems", icon: "pi pi-desktop" },
    ],
  },
];
